import { FC } from 'react';

import { Swimlane } from '@rikstv/play-common/src/components/pages/types';
import { BasicCoreScrollSwimlane } from '@rikstv/play-common/src/components/swimlane/coreScrollSwimlane/BasicCoreScrollSwimlane';

export const RelatedSwimlanes: FC<{ swimlane: Swimlane }> = ({ swimlane }) => {
  {
    /* Disable "vis flere" on this swimlane by assigning large number */
  }
  return <BasicCoreScrollSwimlane swimlane={{ ...swimlane }} />;
};
